import { useRouter } from "./useRouter";
import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { isAuthAtom, productKeyAtom } from "src/atoms";
import { getUserInfoFromLocalStorage } from "src/utils/storage/auth";
import { useGetMyServiceList } from "./api/product/useGetMyServiceList";

// 로그인 유효한지 확인하는 Hook
export function useAuth() {
  const router = useRouter();
  const [isAuth, setIsAuth] = useRecoilState(isAuthAtom);
  const cloudUserInfo = getUserInfoFromLocalStorage()
    ? JSON.parse(getUserInfoFromLocalStorage() as string)
    : null;
  const lang = { router };
  const [productKey] = useRecoilState(productKeyAtom);
  const isIncludePathGoToConsole = ["/", "/login", "/join"];
  const excludeLangPath = router.currentPath.substring(3);
  const { serviceList } = useGetMyServiceList({});
  useEffect(() => {
    if (!cloudUserInfo && isIncludePathGoToConsole.includes(excludeLangPath))
      return;
    else if (!cloudUserInfo) {
      // 로그인 안되어있으면 로그인 페이지로 이동
      if (productKey) {
        router.goLogin();
      } else {
        router.goHome();
      }
    } else {
      // 로그인 되어있으면 콘솔 페이지로 이동
      if (router.currentPath === `/${lang}`) router.goConsole();
      if (router.currentPath === `/${lang}/site/promotion`) {
        // 프로모션 페이지 접근시 서비스 있는지 확인
        if (serviceList?.length > 0) router.goConsole();
      }
    }
  }, [router]);

  return { cloudUserInfo };
}
